import script from "./CustomRadioButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomRadioButton.vue?vue&type=script&setup=true&lang=js"

import "./CustomRadioButton.vue?vue&type=style&index=0&id=037f9a45&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-037f9a45"]])

export default __exports__